// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';

// js utilities
import _ from 'lodash';

// import customized material UI element
import TextField from '../../../../../../common/components/c_TextField';
import PasswordWithValidators from '../../../../../../common/components/f_PasswordWithValidators';
import JoveoTrackingPixel from '../JoveoTrackingPixel';


class PasswordEntry extends Component {
  static propTypes = {
    updatePassword: PropTypes.func,
    password: PropTypes.string,
    passwordIsReady: PropTypes.bool,
    email: PropTypes.string
  }

  constructor(props, context) {
    super(props, context);

    this.resetPasswordState = ::this.resetPasswordState;
  }

  initState = { /* eslint react/sort-comp:0 */
    confirmPassword: '',
    confirmPasswordDirty: false,
    passwordIsValid: false,
    disableUserClosing: true
  }

  state = Object.assign({}, this.initState)

  resetPasswordState() {
    this.setState(Object.assign({}, this.initState));
  }

  passwordChange(event, password, passwordIsValid) {
    if(!this.state.passwordIsValid && passwordIsValid) {
      this.setState(_.merge(this.state, { passwordIsValid }));
    } else if(this.state.passwordIsValid && !passwordIsValid) {
      this.setState(_.merge(this.state, { passwordIsValid }));
    }

    this.props.updatePassword(password, passwordIsValid && password === this.state.confirmPassword);
  }

  confirmPasswordChange(event, confirmPassword) {
    this.setState(_.merge(this.state, {
      confirmPassword
    }));

    if(this.state.passwordIsValid && this.props.password === this.state.confirmPassword) {
      this.props.updatePassword(this.props.password, true);
    } else if (this.props.passwordIsReady) {
      this.props.updatePassword(this.props.password, false);
    }
  }

  confirmPasswordBlur() {
    // make confirm password dirty on first blur
    if(!this.state.confirmPasswordDirty) {
      this.setState(_.merge(this.state, {
        confirmPasswordDirty: true
      }));
    }
  }

  render() {
    return (
      <div className='password-entry'>
        <JoveoTrackingPixel conversionType='preliminary-dropoff' />
        <TextField className='full-width'
                   floatingLabelText='Email'
                   data-id='Email'
                   value={this.props.email}
                   disabled/>
        <PasswordWithValidators value={this.props.password}
                                onChange={::this.passwordChange}/>
        <TextField className='full-width'
                   floatingLabelText='Confirm Password'
                   data-id='Confirm Password'
                   password
                   onChange={::this.confirmPasswordChange}
                   onBlur={::this.confirmPasswordBlur}
                   errorText={this.state.confirmPasswordDirty &&
                              this.state.confirmPassword !== this.props.password &&
                              'Please make sure both password entries are the same' || undefined}/>
      </div>
    );
  }
}


export default PasswordEntry;



// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/r_ApplicationForm/r_CreateUserModal/c_PasswordEntry/index.js